import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

const InfoModal = ({
  data,
  setIsFormShow,
  isFormShow,
  setIsModalShow,
  isModalShow,
  setIsProgressHidden,
}) => {
  const [ isChecked, setIsChecked ] = useState('');
  const [ isCompleted, setIsCompleted ] = useState(false);

  const handleCheck = (value, index) => {
    setIsChecked((prevState) => ({ ...prevState, [ index ]: value }));
  };

  useEffect(() => {
    if (isChecked) {
      const uploadTrueLength = Object.values(isChecked).filter((value) => value)
        .length;
      if (uploadTrueLength === Object.keys(data).length) setIsCompleted(true);
    }
  }, [ isChecked ]);

  return (
    <Modal
      show={ isModalShow }
      onHide={ () => {
        setIsModalShow(false);
      } }
      size='lg'
      centered>
      <Modal.Body>
        <h2 className='d-inline'>Persyaratan</h2>
        <small className='pl-2'>
          <span className='text-danger'>*</span>pastikan setiap persyaratan
          tersedia untuk mulai mengisi form
        </small>
        <ul className='mt-2'>
          {data &&
            data.map((d, i) => (
              <>
                <div className='row'>
                  <div className='col-md col-12'>
                    <li key={ i }>
                      <span style={ { marginBottom: '0' } }>{d.name}</span>
                      <span className='text-danger'>{` | *ekstensi : ${
                        d.extension
                      } | *ukuran maksimal : ${ Math.ceil(
                        d.max_size / 1000000
                      ) } MB`}</span>
                    </li>
                  </div>
                  <div className='col-md-2'>
                    <div
                      className={ `custom-control custom-checkbox ${
                        isFormShow ? 'd-none' : ''
                      }` }>
                      <input
                        type='checkbox'
                        className='custom-control-input'
                        id={ i }
                        onChange={ (e) => handleCheck(e.target.checked, i) }
                      />
                      <label className='custom-control-label' for={ i }>
                        Tersedia
                      </label>
                    </div>
                  </div>
                </div>
              </>
            ))}
        </ul>
        <button
          className={ `${
            isFormShow || !isCompleted ? 'd-none' : ''
          } btn btn-primary float-right` }
          onClick={ () => {
            setIsFormShow(true);
            setIsModalShow(false);
            setIsProgressHidden(false);
          } }>
          Mulai Mengisi Form
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default InfoModal;
